import React from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";
import { FaTimes } from "react-icons/fa";
import { diffStyles } from "../common/DiffViewer";

const PromptDiff = ({ data, onClose }) => {
  const title = data.path.replaceAll("/", " > ");

  const renderHeader = () => {
    return (
      <div className="flex items-center text-sm text-gray-400 px-2 h-8 bg-[#1E1E1E]">
        <div className="w-[calc(50%-1rem)] pr-2">{`${title} [${data.left}]`}</div>
        <div className="w-[calc(50%-1rem)] pl-2">{`${title} [${data.right}]`}</div>
        <div className="w-8 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <FaTimes size={16} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="relative h-full z-100 flex flex-col">
      {renderHeader()}
      <div className="flex-1 overflow-auto dark-slim-scrollbar">
        <ReactDiffViewer
          oldValue={data.original || ""}
          newValue={data.modified || ""}
          splitView={true}
          useDarkTheme={true}
          compareMethod={DiffMethod.WORDS}
          showDiffOnly={false}
          leftTitle={`${title} [${data.left}]`}
          rightTitle={`${title} [${data.right}]`}
          styles={diffStyles}
        />
      </div>
    </div>
  );
};

export default PromptDiff;
